import { FC } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'next-i18next'
import styles from './EncyclopediaNav.module.scss'
import Breadcrumbs from 'components/breadcrumbs/Breadcrumbs'
import EncyclopediaSearchBar from 'components/encyclopedia/search-bar/EncyclopediaSearchBar'

const EncyclopediaNav: FC = () => {
  // i18n
  const { t } = useTranslation('encyclopedia')

  return (
    <nav className={classNames('container', styles['encyclopedia-nav'])}>
      <Breadcrumbs className={styles.breadcrumbs} />
      <EncyclopediaSearchBar className={styles.search} placeholder={t('search.placeholder', 'Zoek in onze encyclopedie...')} />
    </nav>
  )
}

export default EncyclopediaNav
